import { Component, PropsWithChildren } from "react";
import { STORAGE } from "project-config/constants";
import { ErrorPage } from "@renderbus/widgets/components/error-page";
import { useGlobalStore } from "@/store/GlobalStore";
import { getUserId } from "@/utils/getUesrKey";

type PropsType = PropsWithChildren<{}>;

interface ErrorBoundaryState {
  error: object | null;
}

function ErrorPageWrapper() {
  const { userInfo } = useGlobalStore();
  const fallbackUserInfo = userInfo?.userId || Number(getUserId());
  return <ErrorPage userId={fallbackUserInfo} />;
}

export default class ErrorBoundary extends Component<
  PropsType,
  ErrorBoundaryState
> {
  constructor(props: PropsType) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: object) {
    return { error };
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;
    if (error) {
      sessionStorage.setItem(STORAGE.NETWORK_ERROR, JSON.stringify(error));
      return <ErrorPageWrapper />;
    }

    return children;
  }
}
